import { createContext, useContext } from 'react';
export var LocksContext = createContext([]);
export var useLocksContext = function () { return useContext(LocksContext); };
